export default __webpack_public_path__ + "static/media/reporting-people.e7436ca4.png";